export default class UserAgentService {
  static userAgent() {
    return window?.navigator?.userAgent;
  }

  static isRootMobileAgent() {
    return window?.navigator?.userAgent === 'Root Mobile';
  }
}
